// extracted by mini-css-extract-plugin
export default {"link":"AuthNav_link__meMDa","activeLink":"AuthNav_activeLink__Mzsxj"};